import { isMode, type Mode } from '@graal/tokens';

/**
 * Ce que l'utilisateur choisit : un mode, ou « suivre le système ». Ce qui est posé sur
 * `<html data-mode>` reste un `Mode` (`dark` | `light`) : « system » est résolu au rendu.
 */
export const MODE_PREFERENCES = ['dark', 'light', 'system'] as const;
export type ModePreference = (typeof MODE_PREFERENCES)[number];

export function isModePreference(value: unknown): value is ModePreference {
  return value === 'system' || isMode(value);
}

const SYSTEM_LIGHT = '(prefers-color-scheme: light)';

/** Mode du système ; sombre là où `matchMedia` n'existe pas (jsdom, vieux navigateurs). */
export function systemMode(): Mode {
  return typeof window.matchMedia === 'function' && window.matchMedia(SYSTEM_LIGHT).matches
    ? 'light'
    : 'dark';
}

/** Abonnement pour `useSyncExternalStore` : suit le changement de thème du système. */
export function subscribeSystemMode(onChange: () => void): () => void {
  if (typeof window.matchMedia !== 'function') return () => undefined;
  const query = window.matchMedia(SYSTEM_LIGHT);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

export function resolveMode(preference: ModePreference): Mode {
  return preference === 'system' ? systemMode() : preference;
}
